// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { setPathDatabaseHighlightedIds } from 'redux/modules/pathDatabase/actions'

const togglePathDatabaseHighlightedId = path_id => (dispatch, getState) => {
  const {
    highlightedPathIds: oldHighlightedPathIds,
  } = getState().pathDatabase

  // determine if we are trying to remove this path or add it to the highlighted list.
  const removeFromHighlights = oldHighlightedPathIds.includes(path_id)

  // if the path_id is already in the highlightedPathIds,
  // then filter it out else add it to the list
  const highlightedPathIds = (
    removeFromHighlights
      ? oldHighlightedPathIds.filter(v => v !== path_id)
      : [...oldHighlightedPathIds, path_id]
  )

  // then save that updated list to redux
  dispatch(setPathDatabaseHighlightedIds(highlightedPathIds))
}

export default togglePathDatabaseHighlightedId
